import { useDeleteLogicoUsuario } from "@/hooks/useDeleteLogicoUsuario";
import type { ClienteFinal } from "@/interfaces/user.interface";
import { AccionesGenericas } from "./AccionesGenericas";
import { EditClienteFinalForm } from "../forms/cliente-final/EditClienteFinalForm";
import { DetalleClienteFinal } from "../dashboards/superAdmin/modales/ModalDetalleClienteFinal";

type AccionesClienteFinalCellProps = {
  cliente: ClienteFinal;
  queryKey: ReadonlyArray<unknown>;
};

export default function AccionesClienteFinalCell({
  cliente,
  queryKey,
}: AccionesClienteFinalCellProps) {
  const { mutate } = useDeleteLogicoUsuario({
    queryKey,
  });

  return (
    <AccionesGenericas
      data={cliente}
      id={cliente.idUsuario}
      label="Cliente Final"
      queryKey={queryKey}
      FormularioEdicion={EditClienteFinalForm}
      onDelete={(id) => mutate(id)}
      DetalleContenido={DetalleClienteFinal}
    />
  );
}
